import { render, staticRenderFns } from "./InterventionView.vue?vue&type=template&id=f20abee8&"
import script from "./InterventionView.vue?vue&type=script&lang=js&"
export * from "./InterventionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports